module.exports = __webpack_public_path__ + "static/next_wave_neurodiagnostics_customer_story_thumbnail-f4543259b57c6766ef1d951582ceb1ff.png";